// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__WcSie","loading":"styles_loading__3hCz1","loadingIcon":"styles_loadingIcon__29VjD"};